import React, { useContext } from "react";
import styled from "styled-components";

import { ShowLandingContext } from "./../Landing/ShowLandingContextWrapper";
import { CurrentThemeContext } from "./../common/ThemeContextWrapper";

const CopyrightFooter = styled.footer`
    position: fixed;
    bottom: 0;
    right: 10px;
    z-index: 10;

    small {
        color: ${props => props.showLanding || props.currentTheme === "lvoid" ? "#333" : "#FFF"};

        transition-property: color;
        transition-duration: ${props => props.theme.landingTransitionDuration}s;
    }

    @media print {
        display: none;
    }

    @media only screen and (max-width: ${props => props.theme.mobileCutoffWidth}px) {
        left: 10px;
        right: unset;
    }
`;

CopyrightFooter.displayName = "CopyrightFooter";

function Copyright() {
    const { showLanding } = useContext(ShowLandingContext);
    const { currentTheme } = useContext(CurrentThemeContext);

    return (
        <CopyrightFooter showLanding={showLanding} currentTheme={currentTheme}>
            <small>&copy; Copyright 2019-Present Chris Hill</small>
        </CopyrightFooter>
    );
}

export default Copyright;
